import React, { useContext, useMemo } from "react";
import * as notify from "shared/notify";

import Modal from "components/modal";
import { ShotContext } from "../context";
import { getRemovableEmptySlots } from "../lib/helpers";
import { useModal } from "../../../shared/hooks/use-modal";

const RemoveEmptySlots = ({ isReadOnly, isUploading }) => {
    const { shotsByLocale, packageTemplate, removeEmptyShots } = useContext(ShotContext);
    const { open, onOpen, onClose } = useModal();
    const count = getRemovableEmptySlots(shotsByLocale, packageTemplate).length;
    const isBusy = useMemo(
        () => Object.values(shotsByLocale).some((shots) => shots.some((shot) => shot.isUploading || shot.isTemporary || shot.copyInProgress)),
        [shotsByLocale]
    );

    const handleRemove = () => {
        const removed = removeEmptyShots();
        onClose();
        notify.success(`${removed} empty slot(s) removed`);
    };

    return (
        <>
            <button
                type="button"
                className="button"
                disabled={isReadOnly || isBusy || isUploading || count === 0}
                onClick={onOpen}
            >
                Remove Empty Slots
            </button>
            <Modal
                show={open}
                hideClose={true}
            >
                <h2>Remove empty slots?</h2>
                <p>{count} empty slot(s) will be removed from all locales. Required and coding slots are kept.</p>
                <div className="button-group">
                    <button
                        type="button"
                        className="button"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="button -primary -right"
                        onClick={handleRemove}
                    >
                        Remove
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default RemoveEmptySlots;
